import React from 'react';
import Marquee from 'react-fast-marquee';

import { IoLogoJavascript } from "react-icons/io";
import { FaReact } from "react-icons/fa6";
import { FaAngular } from "react-icons/fa";
import { SiRubyonrails } from "react-icons/si";
import { SiTailwindcss } from "react-icons/si";
import { FaGit } from "react-icons/fa";
import { FaGithubSquare } from "react-icons/fa";
import { FaBootstrap } from "react-icons/fa";
import { SiRedux } from "react-icons/si";
import { SiTypescript } from "react-icons/si";
import { SiNextdotjs } from "react-icons/si";


const Marque = () => {
  return (
    <div className='bg-[--background] text-center'>
        <h1 className='text-xl font-bold py-4 px-2 text-[var(--text-primary)] uppercase'>Tech <span className='text-[#8c1985]'>Stack</span></h1>
        <Marquee pauseOnClick >
            <div className='px-4 py-6'>
                <IoLogoJavascript className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <SiTypescript className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <SiNextdotjs className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <FaReact className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <FaAngular className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <SiRubyonrails className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <FaGithubSquare className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <FaGit className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <SiTailwindcss className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <FaBootstrap className='marque_icon' style={{fontSize: "3em"}} />
            </div>

            <div className='px-4 py-6'>
                <SiRedux className='marque_icon' style={{fontSize: "3em"}} />
            </div>


            
            

        </Marquee>
    </div>
  )
}

export default Marque